var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPotentialtalents(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.405,
    height: 35.291,
    viewBox: "0 0 31.405 35.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-potential-2255540",
    transform: "translate(0 0.001)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M303.62,189.86l-.436,1,2.753,1.2a2.223,2.223,0,1,0,.417-1.006Zm4.528,1.344a1.135,1.135,0,1,1-.824.344,1.136,1.136,0,0,1,.824-.344Z",
    transform: "translate(-290.7 -178.412)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M139.689,23.319a13.966,13.966,0,0,0-14.624,14.7L121.573,46.9h4.912v4.434a2.176,2.176,0,0,0,2.176,2.176h3.21v5.084h13.962V51.256h0a13.414,13.414,0,0,0,5.952-7.832q.327-1.161.657-2.321A13.966,13.966,0,0,0,139.689,23.32Zm-.048,1.087h0A12.879,12.879,0,0,1,151.4,40.8q-.331,1.162-.658,2.325a12.327,12.327,0,0,1-5.99,7.5v6.881h-11.79V52.422h-4.3a1.088,1.088,0,0,1-1.088-1.089V45.811h-4.4l2.994-7.618a12.878,12.878,0,0,1,13.474-13.785Z",
    transform: "translate(-121.573 -23.304)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M254.836,97.75V99.6h-1.088V97.75a7.838,7.838,0,0,0-4.6,1.906l1.307,1.307-.77.769-1.307-1.307h0a7.838,7.838,0,0,0-1.905,4.6h1.848v1.088h-2.939a8.927,8.927,0,1,1,17.821,0h-2.939v-1.088h1.848a7.841,7.841,0,0,0-1.906-4.6l-1.307,1.307-.77-.769,1.307-1.307a7.839,7.839,0,0,0-4.6-1.906Z",
    transform: "translate(-236.855 -91.601)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPotentialtalents);
export default __webpack_public_path__ + "static/media/Potentialtalents.76f0f39b6f4566cffdf2818e068c60dd.svg";
export { ForwardRef as ReactComponent };